export default function ComparisonTable() {
  const features = [
    { feature: "Trusted Products", spreadsheet: true, random: false },
    { feature: "Price Comparison", spreadsheet: true, random: false },
    { feature: "Seller Ratings", spreadsheet: true, random: false },
    { feature: "Updated Weekly", spreadsheet: true, random: false },
    { feature: "Buying Guides", spreadsheet: true, random: false },
    { feature: "Community Reviews", spreadsheet: true, random: false },
    { feature: "Quality Verification", spreadsheet: true, random: false },
    { feature: "Category Organization", spreadsheet: true, random: false },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Why Choose Us
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            AllChinaBuy Spreadsheet vs Random Sellers
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            See why thousands of buyers trust our curated spreadsheet over random marketplace browsing
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70">
          <div className="grid grid-cols-3 bg-foreground-900 text-white">
            <div className="px-5 py-4 text-sm font-semibold">Feature</div>
            <div className="px-5 py-4 text-sm font-semibold text-center bg-accent-600">
              AllChinaBuy Spreadsheet
            </div>
            <div className="px-5 py-4 text-sm font-semibold text-center">
              Random Sellers
            </div>
          </div>

          {features.map((row, idx) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-background-200/50 ${
                idx % 2 === 0 ? "bg-background-50" : "bg-background-100"
              }`}
            >
              <div className="px-5 py-4 text-sm text-foreground-700 font-medium">
                {row.feature}
              </div>
              <div className={`px-5 py-4 text-center ${idx % 2 === 0 ? "bg-accent-50/30" : "bg-accent-50/20"}`}>
                {row.spreadsheet ? (
                  <span className="inline-flex items-center gap-1 text-accent-600 text-sm font-semibold">
                    <i className="ri-check-line text-lg"></i> Yes
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-foreground-300 text-sm">
                    <i className="ri-close-line text-lg"></i> No
                  </span>
                )}
              </div>
              <div className="px-5 py-4 text-center">
                {row.random ? (
                  <span className="inline-flex items-center gap-1 text-accent-600 text-sm font-semibold">
                    <i className="ri-check-line text-lg"></i> Yes
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-foreground-300 text-sm">
                    <i className="ri-close-line text-lg"></i> No
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}